"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var themes = {
  anytime: {
    primary: '#7d61b4',
    secondary: '#482193',
    tertiary: '#222',
    quaternary: '#000'
  },
  deepGreen: {
    primary: '#018213',
    secondary: '#07cb22',
    tertiary: '#333',
    quaternary: '#222'
  }
};
exports.default = themes;